/**
 * Mapping dichiarativo provider → flag permesso che ne governa il collegamento,
 * unica fonte per backend (guard e dettagli del registry) e webapp (visibilità
 * delle card). Più ampio di `ERP_PROVIDER_PERMISSION` (che gatea le sole route
 * ERP): qui rientra ogni connettore con un flag dedicato, ERP o no. Un provider
 * assente non ha requisiti di permesso (es. i connettori "coming soon").
 *
 * Le chiavi sono i valori dell'enum Prisma `IntegrationProvider`.
 */
export const INTEGRATION_PROVIDER_PERMISSION = {
    COMPUTER_GROSS: 'canAccessSettings',
    JET_HR: 'canConnectJetHr',
    REVISO: 'canConnectReviso',
    PAYPAL: 'canConnectPaypal',
};
//# sourceMappingURL=integration-permissions.js.map